import React, { useState } from 'react';
import { faqs } from '../../mock/mock';
import { Plus, Minus, MessageCircle } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';

export default function FAQ() {
  const [open, setOpen] = useState(0);
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const { toast } = useToast();

  const submit = (e) => {
    e.preventDefault();
    toast({ title: 'Message received 💝', description: 'A wedding friend will reply within 24 hours.' });
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <section id="faq" className="py-24 lg:py-32 bg-[#FBF7F2]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">
        <div className="lg:col-span-2">
          <p className="section-eyebrow">Got questions?</p>
          <h2 className="font-serif text-4xl lg:text-5xl mt-3 text-[#2A2A2A] leading-tight">
            Everything you wanted <span className="italic text-[#7B2C3B]">to ask</span>.
          </h2>
          <p className="mt-5 text-[#4A4A4A] leading-relaxed">
            If you can’t find what you’re looking for, send us a note. We reply with the warmth of a friend and the clarity of a planner.
          </p>

          <form onSubmit={submit} className="mt-8 soft-card rounded-2xl p-6 space-y-4">
            <h3 className="font-serif text-xl text-[#2A2A2A] flex items-center gap-2">
              <MessageCircle className="w-5 h-5 text-[#7B2C3B]" />
              Write to us
            </h3>
            <input
              required
              placeholder="Your name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-[#FBF7F2] text-sm focus:outline-none focus:border-[#7B2C3B] transition-colors"
            />
            <input
              required
              type="email"
              placeholder="Email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-[#FBF7F2] text-sm focus:outline-none focus:border-[#7B2C3B] transition-colors"
            />
            <textarea
              required
              rows={4}
              placeholder="How can we help?"
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-[#FBF7F2] text-sm focus:outline-none focus:border-[#7B2C3B] transition-colors resize-none"
            />
            <button type="submit" className="btn-primary w-full py-3 rounded-full text-sm font-medium">
              Send message
            </button>
          </form>
        </div>

        <div className="lg:col-span-3 space-y-3">
          {faqs.map((f, i) => {
            const active = open === i;
            return (
              <div
                key={i}
                className={`rounded-2xl border transition-all duration-300 ${
                  active ? 'bg-white border-[#D9B8A6] shadow-sm' : 'bg-white border-[#EFE3D8]'
                }`}
              >
                <button
                  onClick={() => setOpen(active ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 lg:p-6 text-left"
                >
                  <span className="font-serif text-lg lg:text-xl text-[#2A2A2A]">{f.q}</span>
                  <span className="w-8 h-8 rounded-full bg-[#F4E4DA] flex items-center justify-center flex-shrink-0">
                    {active ? <Minus className="w-4 h-4 text-[#7B2C3B]" /> : <Plus className="w-4 h-4 text-[#7B2C3B]" />}
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    active ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 lg:px-6 pb-6 text-[#4A4A4A] leading-relaxed">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
